
import Vue from 'vue';

const sizesDirs = ['320x214', '640x427', '1280x853'];

export default Vue.extend({
  name: 'ImageEngrais',
  props: {
    numArticle: {
      type: String,
      required: true
    },
    srcWidth: {
      type: Number,
      default: window.innerWidth
    }
  },
  computed: {
    bestSrcDir () {
      let dir = null as string;
      for (const _dir of sizesDirs.slice().reverse()) {
        const width = parseInt(_dir.split('x')[0]);
        if (width > this.srcWidth) {
          dir = _dir;
        }
      }

      return dir || sizesDirs[sizesDirs.length - 1];
    },
    url (): string {
      try {
        const dir = this.bestSrcDir;
        return require(`@/assets/photos_engrais/${dir}/${this.numArticle}.jpg`);
      } catch (e) {
        return require(`@/assets/photos_engrais/fallback.png`);
      }
    }
  }
});
